import React from "react";

const itemsByLetter = (items) => {
    const grouped = items.reduce((acc, item) => {
        const displayName = item.DisplayName.trim();
        const firstChar = displayName[0];
        const isDigit = /^\d/.test(firstChar);
        const firstLetter = isDigit ? "#" : firstChar.toUpperCase();

        if (!acc[firstLetter]) {
            acc[firstLetter] = [];
        }
        acc[firstLetter].push(item);
        return acc;
    }, {});

    const sortedKeys = Object.keys(grouped).sort((a, b) => {
        if (a === "#") return -1;
        if (b === "#") return 1;
        return a.localeCompare(b);
    });

    const groupedArray = sortedKeys.map((letter) => ({
        label: letter,
        items: grouped[letter],
    }));

    return groupedArray;
};

const NavigationAllProducts = (props) => {
    const groupedItems = itemsByLetter(props.items.filter((x) => !!x.DisplayName));

    return (
        <nav className="nav-child all-products-list">
            {groupedItems.map((group) => (
                <section key={group.label}>
                    <span className="h5">{group.label}</span>
                    <ul>
                        {group.items.map((item, index) => (
                            <li
                                className={`nav-item ${item.IsActive !== null && item.IsActive ? "active" : ""}`}
                                key={index}
                            >
                                <a className="btn d-flex" rel="nofollow" href={item.Url}>
                                    {item.DisplayName}
                                </a>
                            </li>
                        ))}
                    </ul>
                </section>
            ))}
        </nav>
    );
};

export default NavigationAllProducts;
